import React, {
  useState,
  useEffect,
} from "react";
import { Form } from "antd";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";

import FileSaver from "file-saver";
import * as XLSX from "xlsx";

import useNotification from "../../../../hooks/newUXNotification";
import { useLoading } from "../../../../hooks/loading";

import { useDispatch, useSelector } from "react-redux";

import {
  postImportCollaborator,
  clearImportCollaboratorResult,
} from "../../../../redux/modules/employee/actions";

import Button from "../../../../newUXComponents/Button";
import Dragger from "../../../../newUXComponents/Dragger";
import BackArrow from "../../../../newUXAssets/icons/BackArrow";

import {
  Container,
  ButtonContainer,
  FormContainer,
  ReturnLink,
  Title,
  NumericalInfoContainer,
  NumericalInfoText,
  ImportErrorContainer,
  BtnTemplate,
} from "./styles";

import { INITIAL_VALUES, validation } from "./validations";

const ImportCollaborator = ({
  open,
  handleClose,
  id,
  data,
  isExhibitor,
  typesCredentials,
  idContract,
  eventId,
  callbackSuccess,
}) => {
  const intl = useIntl();
  const [form] = Form.useForm();
  const history = useHistory();
  const dispatch = useDispatch();
  const notification = useNotification();
  const { handleLoading } = useLoading();

  const {
    event,
    contract
  } = useSelector((state) => state.initialSettings);
  const {
    importCollaboratorResult,
  } = useSelector((state) => state.employee);
  const [showImportOutput, setShowImportOutput] = useState(false);

  const handleDownloadTemplate = () => {
    FileSaver.saveAs(
      `${process.env.PUBLIC_URL}/collaborator_template.xlsx`,
      "Collaborator_Template.xlsx"
    );
  };

  const handleDownloadErrorReportFile = () => {
    const errorColumns = [["Colaborador", "Erro retornado"]];

    const worksheet = XLSX.utils.json_to_sheet(
        importCollaboratorResult.errorsOutputList);
    XLSX.utils.sheet_add_aoa(worksheet, errorColumns, { origin: "A1" });

    const csvOutput = XLSX.utils.sheet_to_csv(worksheet);
    const csvBlobData = new Blob(
        [String.fromCharCode(0xFEFF), csvOutput],
        { type: "text/csv;charset=utf-8" });
    FileSaver.saveAs(csvBlobData, "import_collaborators_errors.csv");
  };

  const handleGoBack = () => {
    history.push("/credentials/register");
  };

  const callBackError = (message) => {
    handleLoading(false);
    if (message === -10016) {
      setShowImportOutput(true);
    } else {
      setShowImportOutput(false);
    }
    notification.displayError(
      intl.formatMessage({ id: "api.error." + message }),
      "post-import-collaborator-error-message"
    );
  };

  const callBackSuccess = (message) => {
    handleLoading(false);
    if (message === 10012) {
      notification.displayWarning(
        intl.formatMessage({ id: "success." + message }),
        "post-import-collaborator-warning-message"
      );
    } else {
      notification.displaySuccess(
        intl.formatMessage({ id: "success." + message }),
        "post-import-collaborator-success-message"
      );
    }
    setShowImportOutput(true);
  };

  const onFinish = (values) => {
    if (!event || !contract) return;

    handleLoading(true);

    var formData = new FormData();

    formData.set(
        "file",
        values.importCollaboratorFile.file);
    formData.set("fastTrack", false);

    dispatch(
      postImportCollaborator({ formData, callBackError, callBackSuccess })
    );
  };

  useEffect(() => {
    dispatch(clearImportCollaboratorResult());

    if (!event?.value && !contract?.value) {
      notification.displayInfo(
        intl.formatMessage({ id: "error.contract_not_selected" }),
        "event-not-selected-message"
      );
    } else {
      notification.close("event-not-selected-message");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [event?.value, contract?.value]);

  return (
    <Container>
      <ReturnLink onClick={handleGoBack}>
        <BackArrow />
        <p>{intl.formatMessage({ id: "goback" })}</p>
      </ReturnLink>
      <Title>{intl.formatMessage({ id: "import_collaborator" })}</Title>
      <BtnTemplate>
        <Button
          onClick={() => handleDownloadTemplate()}
          label={intl.formatMessage({ id: "download_template" })}
          type="default"
        />
      </BtnTemplate>
      <FormContainer>
        <Form
          layout="vertical"
          form={form}
          name="import-collaborator-form"
          onFinish={onFinish}
          initialValues={INITIAL_VALUES}
        >
          <Dragger
            name="importCollaboratorFile"
            rules={validation("importCollaboratorFile", intl)}
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            type="XLSX"
          />

          <ButtonContainer>
            <Button
              label={intl.formatMessage({ id: "cancel" })}
              type="link"
              onClick={handleGoBack}
            />
            <Button
              label={intl.formatMessage({ id: "save" })}
              type="primary"
              htmlType="submit"
            />
          </ButtonContainer>
        </Form>
      </FormContainer>
      {showImportOutput && (
        <>
          <NumericalInfoContainer>
            <NumericalInfoText>
              {intl.formatMessage(
                { id: importCollaboratorResult.collaboratorsImportedSuccessfully === 1
                    ? "value_registered_collaborator"
                    : "value_registered_collaborators"
                },
                { value: importCollaboratorResult.collaboratorsImportedSuccessfully }
              )}
            </NumericalInfoText>
            <NumericalInfoText>
              {intl.formatMessage(
                { id: importCollaboratorResult.collaboratorsImportedWithError === 1
                    ? "value_error"
                    : "value_errors"
                },
                { value: importCollaboratorResult.collaboratorsImportedWithError }
              )}
            </NumericalInfoText>
          </NumericalInfoContainer>
          {importCollaboratorResult.collaboratorsImportedWithError > 0 && (
            <ImportErrorContainer>
              <Button
                onClick={() => handleDownloadErrorReportFile()}
                label={intl.formatMessage({ id: "error_report" })}
                type="default"
              />
            </ImportErrorContainer>
          )}
        </>
      )}
    </Container>
  );
};

export default ImportCollaborator;
